/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Training_Zones_RangeInputs */

const en_exp_training_zones_range = /** @type {(inputs: Exp_Training_Zones_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone 1: Recovery. Zone 2: Aerobic/easy. Zone 3: Tempo. Zone 4: Threshold. Zone 5: VO2max and above. Heart rate zones sit between your resting and max HR, pace zones around your threshold pace. An easy day lives mostly in Zone 1–2. The share next to a zone is the part of your session you spent in it.`)
};

const de_exp_training_zones_range = /** @type {(inputs: Exp_Training_Zones_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone 1: Erholung. Zone 2: Aerob/locker. Zone 3: Tempo. Zone 4: Schwelle. Zone 5: VO2max und darüber. Zonen nach Puls liegen zwischen Ruhe- und Maximalpuls, Zonen nach Tempo rund um dein Schwellentempo. Ein lockerer Tag liegt größtenteils in Zone 1–2. Der Anteil neben einer Zone zeigt, wie viel deiner Einheit du darin verbracht hast.`)
};

/**
* | output |
* | --- |
* | "Zone 1: Recovery. Zone 2: Aerobic/easy. Zone 3: Tempo. Zone 4: Threshold. Zone 5: VO2max and above. Heart rate zones sit between your resting and max HR, pac..." |
*
* @param {Exp_Training_Zones_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_training_zones_range = /** @type {((inputs?: Exp_Training_Zones_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Training_Zones_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_training_zones_range(inputs)
	return de_exp_training_zones_range(inputs)
});